import { pick } from 'lodash-es';

import { getGlobalSettings } from '../../../utils/global_settings';

export const rootNode = document.getElementById('about-pics-page');

const { currentUser, permissions: globalPermissions } = getGlobalSettings();

export const initParams = {
  permissions: {
    ...globalPermissions,
    current_user_id: currentUser.id,
    customer_id: currentUser.customerId,
  },
  ...pick(rootNode.dataset, ['store', 'appId']),
  assetsData: JSON.parse(rootNode.dataset.aboutPageData || '{}'),
  app: JSON.parse(rootNode.dataset.appSummary),
};
